import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import RivaziaLogo from "../../assets/rivazia";
import AdbIcon from "@mui/icons-material/Adb";
// import RivaziaLogo from "../../assets/rivazia";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";


const pages = [
  // { title: "Build", url: "/create-survey" },
  // { title: "Share", url: "/share" },
  // { title: "Reports", url: "/reports-and-responses" },
  { title: "Dashboard", url: "/dashboard" },
  // { title: "My Surveys", url: "/my-surveys" },
  // { title: "Plans & Pricing", url: "/PlansandPricing" },
];

const ResponsiveAppBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

   
  // const auth=React.useContext(AuthContext)
  const { signOut, userName }: any = React.useContext(AuthContext);

  const settings = [
    // { title: "Profile", clickHandler: "/profile" },
    // { title: "Account", clickHandler: "/account" },
    // { title: "Dashboard", clickHandler: () => navigate("/dashboard") },
    { title: "Logout 🔒", clickHandler: signOut},
  ];

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  return (
    
    <AppBar position="sticky" sx={{ backgroundColor: "var(--blue)", top: 0 }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography onClick={() => navigate("/dashboard")}
            sx={{
              mr: 3,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "var(--blue)",
              textDecoration: "none",
              // backgroundColor:"white",
              padding: "5px"

            }}
          >
            <RivaziaLogo width="120" height="55" />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.title} onClick={() => navigate(page?.url)} className={`${location.pathname === page.url ? 'header-menu active' : ''}`}>
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography onClick={() => navigate("/dashboard")}
            sx={{
              mr: 3,
              display: { xs: "flex", md: "none" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "var(--blue)",
              textDecoration: "none",
            }}
          >
            <RivaziaLogo width="120" height="80" onClick={() => navigate("/dashboard")} />
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page.title}
                onClick={() => navigate(page?.url)}
                sx={{ my: 2, color: "#ffff", display: "block" }}
              >
                {page.title}
              </Button>
            ))}
          </Box>
              {/* <Theme/> */}
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={userName} src="/static/images/avatar/2.jpg" sx={{ backgroundColor: "var(--green)", color: "black" }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting.title}>
                  <Typography textAlign="center" onClick={setting.clickHandler} sx={{ color: "var(--blue)" }}>
                    {setting.title}
                  </Typography>
                </MenuItem>
              ))}
              {/* <Theme/> */}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
